import { List } from 'immutable';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { ellipsis } from 'helpers';

import { ScannerContext } from '../../Scanner';
import AchievementCircle from '../Circle';
import Button from '../../Button';
import RewardCircle from '../RewardCircle';
import styles from './listitem.scss';

const propTypes = {
  achievement: PropTypes.shape({
    get: PropTypes.func,
  }),
  earnedAt: PropTypes.string,
  debug: PropTypes.oneOfType([
    PropTypes.shape({
      award: PropTypes.func,
      withdraw: PropTypes.func,
    }),
    PropTypes.bool,
  ]),
  onClick: PropTypes.func.isRequired,
};

const ListItem = ({
  achievement,
  earnedAt,
  onClick,
  debug,
}) => (
  <div
    className={classNames(
      styles.achievement,
      { [styles.dimmed]: !earnedAt },
    )}
    key={achievement.get('id')}
    onClick={onClick}
    role="button"
    tabIndex={0}
  >
    <AchievementCircle
      points={achievement.get('points')}
      image_id={achievement.get('image_id')}
      placeholder={!earnedAt}
      count={achievement.get('count')}
    />
    <div className={styles.info}>
      <div className={styles.title}>
        {achievement.get('title')}
      </div>
      <div className={styles.description}>
        {ellipsis(achievement.get('description'), 90, true)}
      </div>
      { earnedAt
        && (
        <div className={styles.earnedAt}>
          <i className="far fa-check" />{' '}
          <Moment fromNow element="span">{earnedAt}</Moment>
        </div>
        )}
    </div>
    {achievement.get('rewards', List()).map((item) => (
      <div
        className={styles.rewards}
        key={item.get('name')}
      >
        <div className={styles.reward}>
          <RewardCircle
            image_id={item.get('image_id')}
          />
          <div className={styles.name}>
            {ellipsis(item.get('name'), 50, true)}
          </div>
        </div>
      </div>
    )).toArray()}
    { /* achievement.get('self_achievable') && !earnedAt && (
      <ScannerContext.Consumer>
        {({ activateScanner, available }) => (
          <Button
            disabled={!available}
            onClick={() => activateScanner()}
          >
            <i className="far fa-qrcode" title="QR code" /> Scan it
          </Button>
        )}
      </ScannerContext.Consumer>
    ) */}
    { debug && (
      <div className={styles.debug}>
        <Button
          className={styles.button}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            debug.award(achievement.get('id'));
          }}
        ><i className="far fa-plus" /> Award
        </Button>
        <Button
          className={styles.button}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            debug.withdraw(achievement.get('id'));
          }}
        ><i className="far fa-trash" /> Withdraw
        </Button>
      </div>
    )}
  </div>
);

ListItem.context = ScannerContext;
ListItem.propTypes = propTypes;
export default ListItem;
